import * as React from 'react';

export function useIsMountedRef(): Readonly<React.MutableRefObject<boolean>> {
  const isMounted = React.useRef(false);
  React.useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}
